/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Badge from '@mui/material/Badge';

import SearchModal from "../search/searchModal";
import useCurrentLocation from "../hooks/useCurrentLocation";
import { findMatchingRoute } from "../../utils";
import { getCustomerDetailsInFirebase } from "../service";
import { theme } from "../../theme";

const Navbar = ({ isFullSidebar, setIsFullSidebar, isCurrentJobPage }) => {
    const { pathname } = useCurrentLocation();
    const [pageName, setPageName] = useState("");
    const [customerDetails, setCustomerDetails] = useState(null);

    const handleKeyPress = (event) => {
        if (event.ctrlKey && event.key === 'k') {
            event.preventDefault();
        }
    };

    useEffect(() => {
        const page_name = findMatchingRoute(pathname);
        setPageName(page_name);

        getCustomerDetailsInFirebase(setCustomerDetails);

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [pathname]);

    const iconsList = [
        {
            title: "Direct",
            type: "DIRECT",
            to: '/jobs/messages',
            icon: 'work',
            count: customerDetails?.user_total_direct_unread_message_count > 0 ? customerDetails?.user_total_direct_unread_message_count : 0
        },
        {
            title: "Dispute",
            type: "DISPUTE",
            to: '/disputes/messages',
            icon: 'mood_bad',
            count: customerDetails?.user_total_dispute_unread_message_count > 0 ? customerDetails?.user_total_dispute_unread_message_count : 0
        },
        {
            title: "Office",
            type: "OFFICE",
            to: '/office/messages',
            icon: 'chat_bubble',
            count: customerDetails?.user_total_office_unread_message_count > 0 ? customerDetails?.user_total_office_unread_message_count : 0
        }
    ];

    const MessagesIcons = () => {
        return (
            <>
                {iconsList.map((item, index) => (
                    <li className="nav-item" key={index}>
                        <Badge
                            badgeContent={item.count}
                            color={theme.sidebar_notification_count_color}
                        >
                            <Link 
                                to={item.to} 
                                className="px-1 py-0 nav-link line-height-0 text-body" 
                                data-bs-toggle="tooltip" 
                                data-bs-placement="bottom" 
                                title={item.title}
                            >
                                <i className="material-symbols-rounded">
                                    {item.icon}
                                </i>
                            </Link>
                        </Badge>
                    </li>
                ))}
            </>
        )
    }

    return (
        <nav 
            className={`navbar navbar-main navbar-expand-lg position-sticky top-2 px-0 py-1 mx-3 border-radius-lg z-index-sticky blur shadow-blur left-auto ${isCurrentJobPage && 'pt-2 pb-2'}`} 
            id="navbarBlur" 
            ata-scroll="true"
        >
            <div className="container-fluid py-1 px-2 ">
                {!isCurrentJobPage && (
                    <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                        <a href="#;" className="nav-link p-0 text-body" onClick={() => setIsFullSidebar()}>
                            <div className="sidenav-toggler-inner">
                                <i className="material-symbols-rounded opacity-10 mt-2">
                                    {isFullSidebar ? "menu_open" : "menu"}
                                </i>
                            </div>
                        </a>
                    </div>
                )}
                <nav aria-label="breadcrumb" className="ps-2">
                    <ol className="breadcrumb bg-transparent mb-0 p-0">
                        <li className="breadcrumb-item text-sm">
                            <a className="opacity-5 text-dark" href="#">Pages</a>
                        </li>
                        <li className="breadcrumb-item text-sm text-dark active font-weight-bold" aria-current="page">{pageName}</li>
                    </ol>
                </nav>
                {!isCurrentJobPage && (
                    <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                        <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                            <div className="input-group input-group-outline">
                                <SearchModal/>
                            </div>
                        </div>
                        <ul className="navbar-nav  justify-content-end mt-1">
                            <MessagesIcons/>
                            <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                                <a href="#" className="nav-link p-0 text-body" id="iconNavbarSidenav" onClick={() => setIsFullSidebar(!isFullSidebar)}>
                                    <div className="sidenav-toggler-inner">
                                    <i className="sidenav-toggler-line"></i>
                                    <i className="sidenav-toggler-line"></i>
                                    <i className="sidenav-toggler-line"></i>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </nav>
    );
}

export default Navbar;